import type { Tab } from "../lib/types-explorer";

interface TabSpec {
  value: Tab;
  label: string;
  count: number;
}

interface Props {
  tabs: TabSpec[];
  active: Tab;
  onChange: (t: Tab) => void;
}

export function Tabs({ tabs, active, onChange }: Props) {
  return (
    <nav className="flex gap-0.5 bg-(--color-paper-2) p-[3px] rounded-lg border border-(--color-line)">
      {tabs.map((t) => {
        const isActive = active === t.value;
        return (
          <button
            key={t.value}
            type="button"
            onClick={() => onChange(t.value)}
            className={`flex items-center gap-1.5 px-3.5 py-1.5 rounded-md font-medium text-[13px] ${
              isActive
                ? "bg-(--color-paper) text-(--color-ink) shadow-(--shadow-sm)"
                : "text-(--color-ink-2) hover:text-(--color-ink)"
            }`}
          >
            {t.label}
            <span
              className={`font-mono text-[11px] px-1.5 py-px rounded-full ${
                isActive
                  ? "bg-(--color-accent-soft) text-(--color-accent)"
                  : "bg-(--color-line-2) text-(--color-ink-2)"
              }`}
            >
              {t.count}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
